import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

const customerSetFn = (data) => apiClient.post(`${APP_API_URL}customer/set`, data);

export const useCustomerSetMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: customerSetFn,
    onSuccess: () => {
      queryClient.resetQueries();
    },
  });
};
